import { dialog } from "../../../nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";
import {
  deleteObjectUseCase,
  updateObjectUseCase,
} from "../../../usecases/object";
import { getCurrentUserUseCase } from "../../../usecases/user";
import { setDragLock } from "framer-motion";

class JobListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["employee", "client"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      console.log("objects", objects);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickEdit(objects) {
    const collection = this.view.getCollectionName();
    const query = {
      where: { id: objects.id },
      include: ["all"],
    };
    const response = await this.findObjectUseCase.execute(collection, query);

    const responseTitle = await this.findObjectUseCase.execute(
      "position_titles",
      { where: { id: response[0].id }, include: ["positionTitle2"] }
    );
    console.log("responseTitle: ", responseTitle);
    if (response && response.length > 0) {
      const object = response[0];

      this.view.setState(
        {
          formData: {
            id: object?.id,
            positionTitle: object?.positionTitle,
            positionTitle2: object?.positionTitle2,
            client: object?.client,
            slotVacancy: object?.slotVacancy || "",
            qualificationStandard: object?.qualificationStandard || "",
            jobDescription: object?.jobDescription || "",
            locations: object?.locations || "",
            location: object?.location || "",
            deadline: object?.deadline || "",
          },
        },
        () => {
          // this.view.onClickAdd(object);
          this.view.toggleModal();
        }
      );
    }
    this.view.closeModal();
  }

  async onClickDelete(empDetails) {
    dialog.close();
    const object = empDetails;
    const collection = this.view.getCollectionName();

    await deleteObjectUseCase().execute(collection, object.id);
    this.view.setObjects(this.objects);
    this.reset();
    this.view.setState({ showDetails: false });
    this.getObjects();
  }

  // async handleSubmit(formData) {
  //   const getPosting = JSON.parse(localStorage.getItem("createPosting"));

  //   const collection = this.view.getCollectionName();
  //   const acl = this.view.getAcl();

  //   let sendDetails = {};
  //   if (formData.id !== "") {
  //     console.log("blue", this.view.state.objects);
  //     const {
  //       password,
  //       // id,
  //       // positionTitle,
  //       positionTitles,
  //       ...formDataWithoutId
  //     } = formData;
  //     sendDetails = { ...formDataWithoutId };
  //   } else {
  //     const { id, ...formDataWithoutId } = formData;
  //     sendDetails = { ...formDataWithoutId, status: "Active" };
  //   }

  //   sendDetails.acl = acl;
  //   sendDetails.positionTitle = formData?.positionTitle;

  //   if (getPosting?.id == "create") {
  //     delete sendDetails.id;
  //     localStorage.removeItem("createPosting");
  //   }

  //   this.view.setState({ formData: {} });

  //   console.log("ito ba un?", sendDetails);

  //   await this.upsertUseCase.execute(collection, sendDetails);
  //   this.view.setObjects(this.objects);
  //   this.view.closeModal();
  //   this.reset();
  //   this.getObjects();
  // }
  async handleSubmit(formData) {
    const getPosting = JSON.parse(localStorage.getItem("createPosting"));
    const collection = this.view.getCollectionName();
    const acl = this.view.getAcl();

    let sendDetails = {};

    if (formData.id !== "") {
      console.log("blue", this.view.state.objects);
      const { password, positionTitles, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId };
    } else {
      const { id, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId, status: "Active" };
    }

    sendDetails.acl = acl;
    sendDetails.positionTitle = formData?.positionTitle;
    sendDetails.client = { id: formData?.client?.id };
    sendDetails.positionTitle2 = { id: formData?.positionTitle2?.id };

    if (getPosting?.id === "create") {
      delete sendDetails.id;
      localStorage.removeItem("createPosting");
    }

    this.view.setState({ formData: {} });

    const locations = formData.locations || [];

    if (locations.length > 1) {
      for (const loc of locations) {
        const locationBasedDetails = {
          ...sendDetails,
          location: loc.name,
        };

        await this.upsertUseCase.execute(collection, locationBasedDetails);
      }
    } else if (locations.length === 0) {
      await this.upsertUseCase.execute(collection, sendDetails);
    } else {
      if (locations.length === 1) {
        sendDetails.location = locations[0].name;
      }
      await this.upsertUseCase.execute(collection, sendDetails);
      console.log("update", sendDetails);
    }

    this.view.setObjects(this.objects);
    this.view.setState({ showDetails: false });
    this.view.closeModal();
    this.reset();
    this.getObjects();
  }
}

export default JobListPresenter;
